const PER_DEPENDENT_DEDUCTION = 2275.08;
const MAX_EDUCATION_DEDUCTION = 3561.5;


const sumUntilMax = (p, c) => {
  return p + Math.min(MAX_EDUCATION_DEDUCTION, Number(c))
}

export const getOtherDeduction = (
  yearlyActualIncome,
  dependents,
  ownEducationYearlyExpenses,
  medicalExpense,
  alimonyYearlyExpenses,
) => {
  const dependentsDeduction = dependents.reduce(sumUntilMax, 0) + (PER_DEPENDENT_DEDUCTION * dependents.length)

  const educationDeduction = Math.min(
    MAX_EDUCATION_DEDUCTION,
    ownEducationYearlyExpenses
  );
 const otherDeduction = dependentsDeduction + educationDeduction + medicalExpense + alimonyYearlyExpenses
  return {
    otherDeduction,
    dependentsDeduction,
    educationDeduction,
    medicalExpense,
    alimonyYearlyExpenses,
  }
};
